import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select", "warning"]

  connect() {
    $(this.selectTarget).selectpicker()
    this.adSelect.addEventListener('change', () => this.toggleWarningAndUpdateDevice())
    this.selectTarget.addEventListener('change', () => this.updateWarning())
    this.parent.addEventListener('default-device-changed', () => this.updateDeviceSelection())
    this.toggleWarningAndUpdateDevice()
  }

  toggleWarningAndUpdateDevice() {
    this.updateWarning()
    this.updateDeviceSelection()
  }

  shouldShowWarning() {
    const adId = this.adSelect.value
    if (!adId) return false
    return !this.adDimensions
  }

  updateWarning() {
    const shouldWarn = this.shouldShowWarning()
    this.warningTarget.classList.toggle('d-none', !shouldWarn)
    if (shouldWarn) $(this.warningTarget).tooltip()
  }

  updateDeviceSelection() {
    if (this.deviceMode === 'automatic') {
      this.setSmartDevice()
    } else {
      this.setSpecificDevice(this.deviceMode)
    }
  }

  setSmartDevice() {
    const dimensions = this.adDimensions
    const deviceKinds = this.adSizeDeviceKindMap[dimensions] || []
    const deviceIds = deviceKinds.map(kind => this.deviceKindIdMap[kind]).filter(Boolean)
    const selectedDeviceId = deviceIds.length > 0 ? deviceIds[0] : this.defaultDeviceId

    $(this.selectTarget).selectpicker('val', [selectedDeviceId])
    $(this.selectTarget).selectpicker('refresh')
  }

  setSpecificDevice(deviceId) {
    $(this.selectTarget).selectpicker('val', [deviceId])
    $(this.selectTarget).selectpicker('refresh')
  }

  get parent() {
    return this.element.closest('[data-controller="screenshot-sets"]')
  }

  get adSizeDeviceKindMap() {
    return this.parent ? JSON.parse(this.parent.dataset.screenshotSetsAdSizeDeviceKind) : {}
  }

  get deviceKindIdMap() {
    return this.parent ? JSON.parse(this.parent.dataset.screenshotSetsDeviceKindIdMap) : {}
  }

  get defaultDeviceId() {
    return this.parent ? this.parent.dataset.screenshotSetsDefaultDeviceId : null
  }

  get defaultDeviceSelector() {
    return this.parent?.querySelector('[data-target="screenshot-sets.defaultDeviceSelector"]')
  }

  get deviceMode() {
    return this.defaultDeviceSelector ? this.defaultDeviceSelector.value : 'automatic'
  }

  get adSelect() {
    return this.element.closest('tr.nested-fields')?.querySelector('[data-target="screenshot-sets.adSelect"]')
  }

  get adDimensions() {
    const adSelect = this.adSelect
    if (!adSelect) return null
    const adId = adSelect.value
    if (!adId) return null
    const option = adSelect.querySelector(`option[value="${adId}"]`)
    return option ? option.dataset.dimensions : null
  }
}
